import { Component } from '@angular/core';
import { UserdataService } from '../../../../service/userdata.service';

@Component({
  selector: 'app-license-settings',
  standalone: false,

  templateUrl: './license-settings.component.html',
  styleUrl: './license-settings.component.scss'
})
export class LicenseSettingsComponent {
  user: any;

  constructor(
    private userService: UserdataService,
  ) {
    this.userService.data.subscribe((data) => {
      this.user = data;
    });
  }
}
